/** Deployment scope only; absent build flag preserves existing environments. */
export const deferredDeploymentFeatures = [
    "trading", "aviabooking", "restaurantMenus", "loyaltyLevels",
    "promotions", "marketingCampaigns", "programMarket",
] as const

export type DeploymentFeature = typeof deferredDeploymentFeatures[number]

export const isDeploymentFeatureEnabled = (feature: DeploymentFeature): boolean => {
    const phase1 = typeof __OEM_TIMEWEB_PHASE1__ !== "undefined" && __OEM_TIMEWEB_PHASE1__ === true
    return !(phase1 && deferredDeploymentFeatures.includes(feature))
}

const featurePaths: Record<DeploymentFeature, readonly string[]> = {
    trading: ["/social-market/pair"],
    aviabooking: ["/avia-booking"],
    restaurantMenus: ["/restaurant-menus"],
    loyaltyLevels: ["/loyalty-levels"],
    promotions: ["/promotions"],
    marketingCampaigns: ["/marketing-campaigns"],
    programMarket: ["/social-market"],
}

export const getDisabledDeploymentFeature = (pathname: string): DeploymentFeature | undefined => {
    // React Router matches decoded paths without case sensitivity by default.
    let path = pathname
    try { path = decodeURIComponent(path) } catch { /* Invalid URI is left to the router. */ }
    path = path.toLowerCase()
    return deferredDeploymentFeatures.find(feature =>
        !isDeploymentFeatureEnabled(feature) && featurePaths[feature].some(prefix =>
            path === prefix || path.startsWith(`${prefix}/`)
        )
    )
}
